'use client';

import type { MouseEvent } from 'react';
import { PERSONAL_DATA_CONSENT_PATH, MARKETING_CONSENT_PATH, PRIVACY_POLICY_PATH } from '@/lib/legal/consent';

const linkProps = { target: '_blank', rel: 'noopener noreferrer', className: 'underline hover:no-underline', onClick: (event: MouseEvent) => event.stopPropagation() };

export function PersonalDataConsentText() {
  return <>Я даю <a href={PERSONAL_DATA_CONSENT_PATH} {...linkProps}>согласие на обработку персональных данных</a>.</>;
}

export function MarketingConsentText({ optional = true }: { optional?: boolean }) {
  return <>Я даю <a href={MARKETING_CONSENT_PATH} {...linkProps}>согласие на получение рекламных сообщений</a>{optional ? ' (необязательно)' : ''}.</>;
}

export function PrivacyPolicyNotice({ className = 'mt-2 text-xs leading-5' }: { className?: string }) {
  return <p className={className}><a href={PRIVACY_POLICY_PATH} {...linkProps}>Политика обработки персональных данных</a> — для ознакомления.</p>;
}
